export class RequestPriceModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new RequestPriceModel(), obj)

    newObj.units = obj.units?.map((unit) => {
      return {
        ...unit,
        unitName: unit?.unit?.unitName,
        id: unit.id ?? unit.unitId,
        unitCode: unit?.unit?.fullUnitCode,

        tower: unit?.unit?.tower,
        floor: unit?.unit?.floor?.name || "",
      }
    })

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
